export const isIOS = /iPhone|iPad/i.test(navigator.userAgent)

export function iOSversion() {
  if (/iP(hone|od|ad)/.test(navigator.platform)) {
    const v: RegExpMatchArray | null = navigator.appVersion.match(
      /OS (\d+)_(\d+)_?(\d+)?/
    )
    return v ? parseInt(v[1]) : 0
  } else {
    return 0
  }
}

export function goBack() {
  if (iOSversion() >= 12) {
    location.href = document.referrer
  } else {
    history.go(-1)
  }
}

export function setBackRefrsh(f?: () => void) {
  try {
    if (iOSversion() >= 12) {
      window.addEventListener(
        'pageshow',
        e => {
          if (
            e.persisted ||
            (window.performance && window.performance.navigation.type == 2)
          ) {
            f ? f() : location.reload()
          }
        },
        false
      )
    }
  } catch (e) {}
}

export function initBlurActive() {
  document.addEventListener(
    'blur',
    (ev: any) => {
      const target: Node | null = ev.target
      if (
        target &&
        (target.nodeName == 'INPUT' || target.nodeName == 'TEXTAREA')
      ) {
        if (
          document &&
          document.activeElement &&
          document.activeElement.tagName !== 'INPUT' &&
          document.activeElement.tagName !== 'TEXTAREA'
        ) {
          const scrollHeight =
            document.documentElement.scrollTop || document.body.scrollTop || 0
          window.scrollTo(0, Math.max(scrollHeight - 1, 0))
        }
      }
    },
    true
  )
}

// 固定body, 为解决 元素的内容滚动, 底部body跟着滚动的问题
let topPos = 0;
export function stopBodyScroll(isFixed:boolean) {
    if (isFixed) {
        topPos = window.scrollY
        document.body.style.position = 'fixed'
        document.body.style.top = -topPos + 'px'
    } else {
        document.body.style.position = ''
        document.body.style.top = ''
        window.scrollTo(0, topPos) // 回到原先的top
    }
}


//解决vant组件 滑动穿透的问题
export function inserted() {
  const scrollTop = document.body.scrollTop || document.documentElement.scrollTop
  document.body.style.cssText += 'position:fixed;width:100%;top:-' + scrollTop + 'px;'
}
// unbind 指令与元素解绑时调用
export function unbind() {
  const body = document.body
  body.style.position = ''
  const top = body.style.top
  document.body.scrollTop = document.documentElement.scrollTop = -parseInt(top)
  body.style.top = ''
}
